import LogoVeloe from './components/LogoVeloe'
import History from './components/History'
import Settings from './components/Settings'
import Location from './components/Location'
import Atention from './components/Atention'
import Estacionamento from './components/Estacionamento'
import Abastecimento from './components/Abastecimento'
import Pedagio from './components/Pedagio'

export default {
  LogoVeloe,
  History,
  Settings,
  Location,
  Atention,
  Estacionamento,
  Abastecimento,
  Pedagio,
}
